// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.download-csv-modal {
  min-height: 340px;
  width: 520px;
  display: flex;
  flex-direction: column;
}
.download-csv-modal__row {
  --gc-form-row-label-width: 200px;
}
.download-csv-modal__content {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  flex: 1;
}
.download-csv-modal__attention {
  padding: var(--g-spacing-3) var(--g-spacing-4);
  margin-block-end: var(--g-spacing-4);
}
.download-csv-modal__radio-group-option {
  line-height: inherit;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/ui/libs/DatalensChartkit/components/ChartKitBase/components/Header/components/Menu/Items/DownloadCsv/DownloadCsv.scss"],"names":[],"mappings":"AAIA;EACI,iBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AAHJ;AAKI;EATA,gCAAA;AAOJ;AAMI;EACI,aAAA;EACA,2BAAA;EACA,sBAAA;EACA,OAAA;AAJR;AAOI;EACI,8CAAA;EACA,oCAAA;AALR;AAQI;EACI,oBAAA;EACA,mBAAA;AANR","sourcesContent":[".download-csv-modal {\n  min-height: 340px;\n  width: 520px;\n  display: flex;\n  flex-direction: column;\n}\n.download-csv-modal__row {\n  --gc-form-row-label-width: 200px;\n}\n.download-csv-modal__content {\n  display: flex;\n  justify-content: flex-start;\n  flex-direction: column;\n  flex: 1;\n}\n.download-csv-modal__attention {\n  padding: var(--g-spacing-3) var(--g-spacing-4);\n  margin-block-end: var(--g-spacing-4);\n}\n.download-csv-modal__radio-group-option {\n  line-height: inherit;\n  align-items: center;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
